<template>
    <content-view class="orderUserDetail">
        <div class="bg-white pl32 pr32 pt32">
            <div class="form form_3 pb16">
                <div class="form-item">
                    <div class="form-item-key">磅单号：</div>
                    <div class="form-item-val">{{ detail.serial }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">交易时间：</div>
                    <div class="form-item-val">
                        {{ $moment.unix(detail.updated_at).format("YYYY-MM-DD HH:mm") }}
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">回收人员：</div>
                    <div class="form-item-val">{{ detail.recycling_name }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">回收人员联系方式：</div>
                    <div class="form-item-val">{{ detail.recycling_phone }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">分拣中心名称：</div>
                    <div class="form-item-val">{{ detail.sorting_name }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">分拣中心电话：</div>
                    <div class="form-item-val">{{ detail.sorting_phone }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">废品品类：</div>
                    <div class="form-item-val">{{ detail.parent_name }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">净重：</div>
                    <div class="form-item-val">{{ detail.weight_amount }}公斤</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">毛重：{{ detail.rough_weight }}</div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">皮重：{{ detail.tare_weight }}</div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">交易金额：</div>
                    <div class="form-item-val">{{ detail.pay_amount }}元</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">支付流水号：</div>
                    <div class="form-item-val">{{ detail.flow }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">自编号：{{ detail.self_serial }}</div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">入场时间：{{ detail.in_time }}</div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">出场时间：{{ detail.out_time }}</div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">车牌号：{{ detail.carNum }}</div>
                    <div class="form-item-val"></div>
                </div>
            </div>
            <div class="form form_3 pt16">
                <div class="form-item">
                    <div class="form-item-key">运营审核意见：{{ detail.jbt_abnor_content }}</div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">运营审核时间：{{ detail.jbt_abnor_time }}</div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item">
                    <div class="form-item-key"></div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">城管审核意见：{{ detail.gov_abnor_content }}</div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">城管审核时间：{{ detail.abnor_time }}</div>
                    <div class="form-item-val"></div>
                </div>
                <div class="form-item" v-if="detail.gov_abnor_type == 3">
                    <div class="form-item-key">不通过原因：{{ detail.abnor_content }}</div>
                    <div class="form-item-val"></div>
                </div>
            </div>
            <div class="form form_3 pb16">
                <div class="paperDetail-item pt24 pb16">
                    <div class="paperDetail-item-title mb24 text-black-85">称重图片</div>
                    <div class="form_img">
                        <div class="form-item" v-if="firstImg.length">
                            <div class="form-item-key">入厂图片：</div>
                            <div class="form-item-val" v-for="(item,index) in firstImg" :key="index">
                                <img class="img" v-if="item" :src="item" alt="" />
                                <img v-else src="../../assets//noimg.jpg" alt="">
                            </div>
                        </div>
                        <div class="form-item" v-else>
                            <div class="form-item-key">入厂图片：</div>
                            <div class="form-item-val">
                                <img width="300px" src="../../assets//noimg.jpg" alt="">
                            </div>
                        </div>
                        <div class="form-item" v-if="secondImg.length">
                            <div class="form-item-key">出厂图片：</div>
                            <div class="form-item-val" v-for="(item,index) in secondImg" :key="index">
                                <img class="img" :src="item" alt="" />
                            </div>
                        </div>
                        <div class="form-item" v-else>
                            <div class="form-item-key">出厂图片：</div>
                            <div class="form-item-val" style="background: #fff;">
                                <img width="300px" src="../../assets//noimg.jpg" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center mt32">
                <div v-if="detail.gov_abnor_type == 1 && from">
                    <a-button class="mr8 mb24" @click="fail">不通过</a-button>
                    <a-button type="primary" class="mr8 mb24" @click="pass">通 过</a-button>
                </div>
                <div v-else><a-button type="primary" class="mr8 mb24" @click="prev">返 回</a-button></div>
            </div>
            <a-modal
                title="不通过原因"
                :visible="visible"
                @ok="handleOk"
                @cancel="handleCancel"
            >
                <a-textarea
                    v-model="shenheData.abnorContent"
                    placeholder="请输入不通过原因"
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                />
            </a-modal>
        </div>
    </content-view>
</template>
<script>
export default {
    name: "accountDetails",
    data() {
        return {
            detail: {},
            orderId: "",
            orderType: "",
            abnorContent:"",
            firstImg: [],
            secondImg: [],
            visible: false,
            confirmLoading: false,
            shenheData: {},
            from: ""
        };
    },
    components: {},
    methods: {
        getDetail() {
            this.$api.account
                .backDetail({ orderId: this.orderId, orderType: this.orderType })
                .then((res) => {
                    if (res.data.first_image.length > 0) {
                        this.firstImg = res.data.first_image;
                    }
                    if (res.data.second_image.length > 0) {
                        this.secondImg = res.data.second_image;
                    }
                    if(res.data.weight_amount < 0){//净重
                        res.data.rough_weight = 0;//毛重
                        res.data.tare_weight = 0;//皮重
                        res.data.weight_amount = 0;
                    }
                    if(res.data.rough_weight != (res.data.weight_amount * 1 + res.data.tare_weight * 1)){
                        
                        res.data.rough_weight = 0;
                        res.data.weight_amount = 0;
                        res.data.tare_weight = 0;
                    }
                    this.detail = res.data;
                });
        },
        // 通过
        pass() {
            this.shenheData.govAbnorType = 2;
            this.doFrontGovAbnor();
        },
        // 不通过
        fail() {
            this.shenheData.govAbnorType = 3;
            this.visible = true;
        },
        // 审核接口
        doFrontGovAbnor() {
            this.shenheData.orderId = this.orderId;
            this.$api.account.frontGovAbnor(this.shenheData).then((res) => {
                    if(res.data.error_no){
                        this.$message.error(res.msg)
                    }else{
                        this.$router.back();
                    }
                });
        },
        prev() {
            this.$router.back();
        },
        // 弹框确定
        handleOk(e){
            e.preventDefault();
            this.doFrontGovAbnor();
        },
        handleCancel() {
            this.visible = false;
        }
    },
    mounted() {
        this.orderId = this.$route.query.orderId;
        this.orderType = this.$route.query.orderType;
        this.from = this.$route.query.str;

        this.getDetail();
    },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.orderUserDetail {
    .form {
        border-bottom: 1px solid $text-color-black-15;
    }
    .form_img {
        .form-item {
            margin-right: 15px;
            min-width: 33.33% !important;
            max-width: unset;
            display: block;
        }
        .form-item-key {
            flex: 1;
        }
    }
    
    .ant-btn-primary {
        width: 81px;
    }
}
</style>
